module.exports = __webpack_public_path__ + "static/Purple-c549fe6e8f3eede9aab4216f7a17c164.png";